import { ApiProperty } from "@nestjs/swagger";

export class VendorReq {
    @ApiProperty()
    id: number;
    @ApiProperty()
    vendorPrice: number;
    @ApiProperty()
    finalPrice?: number;
}